// src/components/layout/Sidebar.js
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { tienePermiso, ROLES_LABELS } from '../../lib/supabase'

const NAV = [
  {
    section: 'General',
    items: [
      { label: 'Dashboard', icon: '📊', path: '/dashboard', permiso: null },
    ]
  },
  {
    section: 'Agro & Ganadería',
    items: [
      { label: 'Animales', icon: '🐄', path: '/animales', permiso: 'agro' },
      { label: 'Vacunas', icon: '💉', path: '/vacunas', permiso: 'vacunas' },
      { label: 'Reproducción', icon: '🐣', path: '/reproduccion', permiso: 'agro' },
      { label: 'Cultivos', icon: '🌾', path: '/cultivos', permiso: 'cultivos' },
    ]
  },
  {
    section: 'Finanzas',
    items: [
      { label: 'Transacciones', icon: '💰', path: '/finanzas', permiso: 'finanzas' },
    ]
  },
  {
    section: 'Operaciones',
    items: [
      { label: 'Clientes', icon: '🤝', path: '/clientes', permiso: 'clientes' },
      { label: 'Reportes', icon: '📈', path: '/reportes', permiso: 'reportes' },
    ]
  },
  {
    section: 'Administración',
    items: [
      { label: 'Usuarios', icon: '👥', path: '/usuarios', permiso: 'usuarios' },
    ]
  },
]

export default function Sidebar() {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  const initials = profile
    ? `${profile.nombre?.[0] ?? ''}${profile.apellido?.[0] ?? ''}`.toUpperCase()
    : '?'

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-text">🌿 Summint Global</div>
        <div className="logo-sub">ERP System</div>
      </div>

      {NAV.map(group => {
        const visible = group.items.filter(item =>
          item.permiso === null || tienePermiso(profile?.rol, item.permiso) || profile?.rol === 'admin'
        )
        if (!visible.length) return null

        return (
          <div className="sidebar-section" key={group.section}>
            <div className="section-label">{group.section}</div>
            {visible.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
              >
                <span style={{ fontSize: 16 }}>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        )
      })}

      <div className="sidebar-footer">
        <div className="user-card" onClick={handleSignOut} title="Cerrar sesión">
          <div className="user-avatar">{initials}</div>
          <div>
            <div className="user-name">{profile?.nombre} {profile?.apellido}</div>
            <div className="user-rol">{ROLES_LABELS[profile?.rol] ?? profile?.rol}</div>
          </div>
        </div>
      </div>
    </aside>
  )
}
